// Scheduling hint only. The server derives and validates identity independently.
export function sessionIdentity(token: string): string | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const payload = JSON.parse(
      atob(
        part
          .replace(/-/g, '+')
          .replace(/_/g, '/')
          .padEnd(Math.ceil(part.length / 4) * 4, '='),
      ),
    );
    if (
      payload.token_use !== 'id' ||
      ![payload.iss, payload.sub, payload.aud, payload.origin_jti].every(
        (value: unknown) => typeof value === 'string' && value.length > 0,
      )
    )
      return null;
    return JSON.stringify([
      payload.iss,
      payload.sub,
      payload.aud,
      payload.origin_jti,
    ]);
  } catch {
    return null;
  }
}
